module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("1. Scan this QR code with your Google Authenticator App. Alternatively, you can use the code: "), _c('code', [_vm._v(_vm._s(_vm.secretKey))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": 'data:image/png;base64,' + _vm.qrCode,
      "alt": "qrcode"
    }
  }), _vm._v(" "), _c('p', [_vm._v("2. Enter the pin from Google Authenticator app:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "code"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-control col-md-4",
    attrs: {
      "id": "code",
      "type": "password",
      "placeholder": "Authenticator Code",
      "name": "code",
      "required": ""
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.enableGoogle2fa
    }
  }, [_vm._v("\n    Enable 2FA\n    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc4f44c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/accountSettings/Google2FA/EnableGoogle2FA.vue
// module id = 994
// module chunks = 0